import { render } from "./hire_vehicle.vue?vue&type=template&id=479a2e57"
import script from "./hire_vehicle.vue?vue&type=script&lang=js"
export * from "./hire_vehicle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__